





























































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import axios from 'axios'
import { Cow } from '@/interfaces/Cow'
import { Dialog } from '@/interfaces/Dialog'
import TimeService from '@/services/time-service'
import CowService from '@/services/cow-service'
import DexieService from '@/services/dexie-service'
import SnackbarService from '@/services/snackbar-service'
import Plotly from 'plotly.js-dist/plotly'
import moment from 'moment'
import ApiService from '@/services/api-service'
import AddView from '@/components/AddView.vue'
import DatetimePicker from '@/components/DatetimePicker.vue'
import CowIcon from '@/components/CowIcon.vue'

@Component({
  components: {
    AddView,
    DatetimePicker,
    CowIcon,
  },
})
export default class DetailsView extends Mixins(
  TimeService,
  CowService,
  DexieService,
  SnackbarService,
  ApiService
) {
  id!: number

  editDialog: Dialog = {
    open: false,
    label: '',
    key: '',
    value: '',
    type: '',
    colValId: null,
    items: [{ text: '', value: 0 }],
  }

  addCowModalIsOpen = false

  deleteDialogOpen = false

  cowIdsAndNumbers: any = []

  deadSoldDay = moment().format('YYYY-MM-DD')

  deleteCowReason = 'deleted'

  cow: Cow | null = null

  pregnantSinceReason = ''

  birthCount = ''

  abortionCount = ''

  inAddingBaby = false

  cowIds: { text: string; value: string }[] | null = null

  babies: Cow[] = []

  delteAbortionItem: any
  dleteAbortionDialogIsOpen = false

  abortionDate = ''
  abortionDateMenu = false
  abortionComment = ''

  headersBabies = [
    { text: 'Numero', value: 'number' },
    { text: 'Fertilidad', value: 'fertility' },
    { text: 'Raza', value: 'race_id' },
    { text: 'Color', value: 'color' },
    { text: 'Preñez', value: 'pregnantSince' },
    { text: 'Hierro', value: 'iron_id' },
    { text: 'Edad', value: 'age' },
    { text: 'Genero', value: 'female' },
    { text: 'Observacion', value: 'observation' },
  ]

  headersAbortions = [
    { text: 'Fetcha', value: 'date' },
    { text: 'Preñez', value: 'pregnant_month' },
    { text: 'Commentario', value: 'comment' },
    { text: '', value: 'actions' },
  ]

  headersRevisions = [
    { text: 'Fetcha', value: 'revision_date' },
    { text: 'Finca', value: 'farm_id' },
    { text: 'Revisada', value: 'revisioned' },
    { text: 'Preñez', value: 'pregnant_since' },
  ]

  defaultCow = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    number: '',
    race_id: 0,
    color: '',
    iron_id: 0,
    pregnancyDate: '',
    birthDate: '',
    observation: '',
    pregnantSince: 0,
    fertility: 'becerro',
    farm_id: this.$store.state.selectedFarmId,
    age: 0.01,
    female: true,
    gender: 'vaca',
    selected: false,
    // eslint-disable-next-line @typescript-eslint/camelcase
    mother_id: null,
    status: 'possession',
  }

  cowNumberExistsError = false
  cowNumberExistsMessage = ''

  items: {
    race_id: { text: string; value: string }[]
    pregnantSince: { text: string; value: number }[]
    age: { text: string; value: number }[]
    gender: { text: string; value: string }[]
    iron_id: { text: string; value: string }[]
    farm_id: { text: string; value: string }[]
    mother_id: { text: string; value: string }[]
    [index: string]: number[] | { text: string; value: string | number }[]
  } = {
    race_id: this.$store.state.account.races.map(r => ({
      text: r.name,
      value: r.id,
    })),
    pregnantSince: this.getPregnantSinces(),
    age: this.getAges(),
    gender: this.getGenders(),
    iron_id: this.$store.state.account.irons.map(i => ({
      text: i.name,
      value: i.id,
    })),
    farm_id: this.$store.state.account.farms.map(f => ({
      text: f.name,
      value: f.id,
    })),
    fertility: this.getFertilities(),
    // eslint-disable-next-line @typescript-eslint/camelcase
    mother_id: null,
  }

  created() {
    // eslint-disable-next-line @typescript-eslint/camelcase
    this.id = parseInt(this.$route.params.id)
    this.$store.state.navbarText = this.$store.state.account.farms.find(
      (f: any) => f.id === this.$store.state.selectedFarmId
    ).name
    this.getCowIdsAndNumbers()
    this.getCow()
  }

  editAddCol(colDefId: number, colValId: number, type: string, label: string) {
    console.log('colValId', colValId)
    this.editDialog.label = label
    this.editDialog.key = null
    this.editDialog.colValId = colValId
    this.editDialog.colDefId = colDefId
    this.editDialog.type = type
    const addCol: any = this.cow.additional_cols.find(
      (c: any) => c.col_def_id === colDefId
    )
    this.editDialog.value =
      addCol.col_def.type === 'select' ? addCol.value_id : addCol.value
    this.editDialog.items = this.$store.state.account.add_col_options
      .filter(o => o.col_def_id === colDefId)
      .map(o => ({ text: o.value, value: o.id }))
    this.editDialog.open = true
  }

  edit(key: string, type: string, label: string) {
    this.editDialog.colValId = null
    this.editDialog.colDefId = null
    this.pregnantSinceReason = ''
    this.editDialog.label = label
    this.editDialog.key = key
    this.editDialog.type = type
    this.editDialog.value = this.cow?.[key] as string
    this.editDialog.items = this.items[key]
    this.editDialog.open = true
  }

  getCowIdsAndNumbers() {
    this.fetchCowIdsAndNumbers().then((cowIdsAndNumbers: any) => {
      this.cowIdsAndNumbers = cowIdsAndNumbers
      this.items.mother_id = cowIdsAndNumbers
    })
  }

  getCow(update = false) {
    this.addCowModalIsOpen = false
    this.$store.state.loading = true
    if (navigator.onLine) {
      axios
        .get(`/cows/${this.$route.params.id}`)
        .then(res => {
          this.cow = res.data
          console.log(this.cow)
          this.cow.additional_cols = this.cow.additional_cols.sort(
            (c1: any, c2: any) => (c1.col_def.name > c2.col_def.name ? -1 : 1)
          )
          this.$store.state.selectedFarmId = this.cow.farm_id
          this.addFrontendValues()
          this.getBabies()
          if (update) {
            this.$db.cows.update(this.cow.id, this.cow)
            this.notify({ text: 'Data actualizado', type: 'success' })
          }
        })
        .catch(error => {
          this.notify({ text: `Server error. ${error}` })
        })
    } else {
      this.$db.cows.get(parseInt(this.$route.params.id)).then((cow: Cow) => {
        this.cow = cow
        this.addFrontendValues()
        this.getBabies()
        if (update) {
          this.$db.cows.update(this.cow.id, this.cow)
          this.notify({ text: 'Data actualizado', type: 'success' })
        }
      })
    }
  }

  addFrontendValues() {
    this.cow!.pregnantSince = this.getPregnantSince(this.cow!.pregnancyDate)
    this.cow!.age = this.getAge(this.cow!.birthDate)
    this.cow!.gender = this.getGender(this.cow.female)
  }

  getBabies() {
    this.$store.state.showAppbar = true
    const url = `/${
      this.cow.status === 'possession'
        ? 'cows'
        : this.cow.state === 'dead'
        ? 'cows-dead'
        : 'cows-sold'
    }`
    this.$store.state.changeBack = url
    console.log(this.$store.state.changeBack)
    this.$store.state.loading = true
    if (navigator.onLine) {
      axios
        .get(`/babies/${this.cow.id}`)
        .then(res => {
          const babies = res.data
          this.babies = this.addPregnantSinceAndAge(babies)
          this.babies = babies.sort((a: Cow, b: Cow) => {
            if (a.pregnantSince === b.pregnantSince) {
              return a.id > b.id ? 1 : -1
            }
            return a.pregnantSince > b.pregnantSince ? -1 : 1
          })
          this.generatePregnancyPlot()
        })
        .catch(error => {
          this.notify({ text: `Server error. ${error}` })
          this.babies = []
          this.$store.state.loading = false
        })
    } else {
      this.$db.cows
        // eslint-disable-next-line @typescript-eslint/camelcase
        .where({ mother_id: this.cow.id })
        .toArray()
        .then((babies: Cow[]) => {
          babies = this.addPregnantSinceAndAge(babies)
          this.babies = babies.sort((a: Cow, b: Cow) => {
            if (a.pregnantSince === b.pregnantSince) {
              return a.id > b.id ? 1 : -1
            }
            return a.pregnantSince > b.pregnantSince ? -1 : 1
          })
          this.generatePregnancyPlot()
        })
    }
  }

  update(isUpdateDeadOrSold: boolean) {
    this.$store.state.loading = true
    const id = this.cow.id
    let url = `/cows/${id}`
    let payload: any = {}

    // cow should be deleted or sold
    if (isUpdateDeadOrSold) {
      const prefix = this.deleteCowReason === 'sold' ? 'v' : 'm'
      if (['v', 'm'].includes(this.cow.number[0])) {
        this.cow.number = this.cow.number.slice(2)
      }
      payload['status'] = this.deleteCowReason
      payload['revisioned'] = false
      payload['number'] = `${prefix}_${this.cow.number}`
      if (this.deleteCowReason === 'sold') {
        payload['date_of_sell'] = this.deadSoldDay
      } else if (this.deleteCowReason === 'dead') {
        payload['date_of_death'] = this.deadSoldDay
      }
    } else {
      // pregnancy
      if (this.editDialog.key === 'pregnantSince') {
        payload = {
          pregnancyDate:
            this.editDialog.value === 0
              ? null
              : this.getPregnancyDate(this.editDialog.value),
        }
        if (this.pregnantSinceReason === 'abortion') {
          payload['abortion_date'] = this.abortionDate
          payload['abortion_comment'] = this.abortionComment
        }
        // age
      } else if (this.editDialog.key === 'age') {
        payload = { birthDate: this.getBirthDate(this.editDialog.value) }
        // gender
      } else if (this.editDialog.key === 'gender') {
        this.changeFertilityAndPregnancy(true)
        payload = {
          female: this.getFemale(this.editDialog.value),
          pregnancyDate: this.getPregnancyDate(this.cow.pregnantSince),
          fertility: this.cow.fertility,
        }
        // iron, race, farm
      } else if (
        [
          'iron_id',
          'race_id',
          'farm_id',
          'observation',
          'number',
          'fertility',
          'color',
          'mother_id',
        ].includes(this.editDialog.key)
      ) {
        payload[`${this.editDialog.key}`] = this.editDialog.value
          ? this.editDialog.value
          : null
      } else {
        // additional cols
        payload[
          `${this.editDialog.colDefId.toString()}_${this.cow.id}_${
            this.editDialog.type
          }`
        ] = this.editDialog.value ? this.editDialog.value : null
        url = `/add-cols/${id}`
        const addCol = this.cow.additional_cols.find(
          (colVal: any) => colVal.id === this.editDialog.colValId
        )
        if (addCol && this.editDialog.type === 'select') {
          addCol.value_id = this.editDialog.value
          addCol.option = this.$store.state.account.add_col_options.find(
            (o: any) => o.id === this.editDialog.value
          )
        } else if (addCol) {
          addCol.value = this.editDialog.value
        }
      }
    }
    if (navigator.onLine) {
      axios
        .patch(url, payload)
        .then(() => {
          this.notify({ text: 'Actualizado exitosamente', type: 'success' })
          this.$store.state.selectedFarmId = payload['farm_id']
            ? payload['farm_id']
            : this.$store.state.selectedFarmId
          if (!isUpdateDeadOrSold) {
            this.getCow()
            this.getAllCowsUpdateCache()
          }
        })
        .catch(error => {
          this.notify({ text: `Server error. ${error}` })
        })
        .finally(() => {
          this.editDialog.open = false
        })
    } else {
      let payloadOffline = payload
      if (url.includes('add-cols')) {
        payloadOffline = { additional_cols: this.cow.additional_cols }
      }
      this.$db.cows.update(this.cow.id, payloadOffline).then(() => {
        this.notify({
          text: 'Actualizado exitosamente (offline)',
          type: 'success',
        })
        this.editDialog.open = false
        this.$db.syncs
          .add({
            method: 'patch',
            farm_id: this.cow.farm_id,
            timestamp: new Date().toISOString(),
            number: this.cow.number,
            url,
            action: 'Vaca: Actualizar',
            message: `Actualizar ${Object.keys(payload)[0]} con ${
              Object.values(payload)[0]
            }`,
            payload,
          })
          .then(() => {
            this.getCow()
          })
      })
    }
  }

  changePregnancyDate(event: number) {
    this.cow!.pregnancyDate = this.getPregnancyDate(event)
  }

  changeBirthDate(event: number) {
    this.cow!.birthDate = this.getBirthDate(event)
  }

  changeFemale(event: number) {
    this.cow!.female = this.getFemale(event)
  }

  /**
   * @param isUpdate - function will be triggered from edit dialog
   *                   or from modus add cow
   */
  changeFertilityAndPregnancy(isUpdate: boolean) {
    // a male cow, can only have fertility macho
    let gender

    // take new value from edit dialog if
    if (isUpdate) {
      gender = this.editDialog.value
    } else {
      gender = this.cow.gender
    }
    if (gender === 'male') {
      this.cow.fertility = 'macho'
      this.cow.pregnantSince = 0
      this.cow.pregnancyDate = ''

      // default for female cow
    } else {
      this.cow.fertility = 'becerro'
    }
  }

  changeGender() {
    this.cow.gender = this.cow.fertility === 'macho' ? 'male' : 'female'
    this.cow.female = this.cow.fertility === 'macho' ? false : true
  }

  closeEditDialog() {
    this.editDialog.open = false
  }

  inputNotValid() {
    return (
      this.cowNumberExistsError ||
      this.cow.number === '' ||
      !this.cow.race_id ||
      this.cow.age === -1 ||
      !this.cow.iron_id ||
      this.cow.gender === '' ||
      this.cow.fertility === '' ||
      this.cow.pregnantSince === -1 ||
      !this.cow.farm_id
    )
  }

  addCow() {
    this.$store.state.loading = true
    this.cow.birthDate = this.getBirthDate(this.cow.age)
    this.cow.female = this.getFemale(this.cow.gender)
    delete this.cow.age
    delete this.cow.pregnantSince
    delete this.cow.gender
    if (this.cow.pregnancyDate === '') {
      delete this.cow.pregnancyDate
    }
    const url = `/cows/`
    const payload = this.cow
    if (navigator.onLine) {
      axios
        .post(url, payload)
        .then(() => {
          this.notify({ text: 'Agregado exitosamente', type: 'success' })
          this.goBack()
        })
        .catch(error => {
          this.notify({ text: `Server error. ${error}` })
        })
    } else {
      this.$db.cows.add(this.cow).then(() => {
        this.notify({ text: 'Agregado exitosamente', type: 'success' })
        this.goBack()
        this.$db.syncs.add({
          method: 'post',
          farm_id: this.cow.farm_id,
          timestamp: new Date().toISOString(),
          number: this.cow.number,
          url,
          action: 'Vaca: Aggragar',
          message: 'Aggregar nueva vaca',
          payload,
        })
      })
    }
  }

  checkcowNumberExists() {
    // only check for number (cow number)
    if (this.editDialog.key !== 'number') {
      return
    }
    if (this.editDialog.value.toString() === '') {
      return
    }
    const cow = this.cowIdsAndNumbers.find(
      (c: Cow) => c.text === this.editDialog.value.toString()
    )
    if (cow) {
      this.cowNumberExistsError = true
      this.cowNumberExistsMessage = `Vaca con numero ${this.editDialog.value.toString()} ya existe`
    } else {
      this.cowNumberExistsError = false
      this.cowNumberExistsMessage = ''
    }
  }

  deleteCow() {
    this.$store.state.loading = true
    console.log(this.cow)
    const url = `/cows/${this.cow.id}`
    if (this.deleteCowReason !== 'deleted') {
      this.update(true)
      this.goBack()
    } else {
      if (navigator.onLine) {
        axios
          .delete(url)
          .then(() => {
            this.notify({ text: 'Elimination exitoso', type: 'success' })
            this.goBack()
          })
          .catch(error => {
            this.notify({ text: `Server error. ${error}` })
          })
      } else {
        this.$db.cows.delete(this.cow.id).then(() => {
          this.notify({ text: 'Elimination exitoso', type: 'success' })
          this.goBack()
          this.$db.syncs.add({
            method: 'delete',
            farm_id: this.cow.farm_id,
            number: this.cow.number,
            url,
            timestamp: new Date().toISOString(),
            action: 'Vaca: Eliminar',
            message: `Eliminar vaca con id ${this.cow.number}`,
          })
        })
      }
    }
  }

  getOverdueMessage() {
    if (this.cow.pregnantSince > 7) {
      return `Preñez: ${this.cow.pregnantSince} meses. Fecha: ${this.cow.pregnancyDate}`
    } else {
      null
    }
  }

  goToDetail(event: any) {
    this.$router.replace({
      path: `/cows/${event.id}`,
    })
    this.getCow()
    // eslint-disable-next-line @typescript-eslint/camelcase
    this.id = parseInt(this.$route.params.id)
  }

  generateId(length: number) {
    let result = ''
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length))
    }
    return result
  }

  addBaby() {
    this.inAddingBaby = true
    const motherNumber = this.cow.number
    const motherId = this.cow.id
    const cow: any = this.defaultCow
    // eslint-disable-next-line @typescript-eslint/camelcase
    cow.mother_id = motherId
    // eslint-disable-next-line @typescript-eslint/camelcase
    cow.mother_number = motherNumber
    cow.fertility = 'becerro'
    // eslint-disable-next-line @typescript-eslint/camelcase
    cow.number = `b_${motherNumber}_${this.generateId(5)}`
    cow.iron_id = 0
    cow.race_id = 0
    cow.farm_id = this.$store.state.selectedFarmId
    cow.pregnantSince = 0
    cow.age = 0.01
    cow.female = true
    cow.gender = this.getGender(this.cow.female)
    cow.birthDate = this.getBirthDate(cow.age)
    this.cow = cow
    this.babies = []
  }

  generatePregnancyPlot() {
    console.log('generating plot')
    if (!this.cow.female) {
      this.$store.state.loading = false
      return
    }
    const color = this.$store.state.colors[
      this.$store.state.account.farms
        .map(f => f.id)
        .indexOf(this.$store.state.selectedFarmId)
    ]
    const today = moment().format('YYYY-MM-DD')
    let points = []
    // birth of cow itself
    points.push({ x: this.cow.birthDate, y: 0, text: '' })

    // babies
    this.babies.forEach((baby: any) => {
      const pregnancyDate = moment(baby.birthDate)
        .subtract(9, 'months')
        .format('YYYY-MM-DD')
      points.push({ x: pregnancyDate, y: 0, text: '' })
      const bithDateM1 = moment(baby.birthDate)
        .subtract(1, 'days')
        .format('YYYY-MM-DD')
      points.push({ x: bithDateM1, y: 9, text: '' })
      points.push({ x: baby.birthDate, y: 0, text: 'birth' })
    })

    // abortions
    this.cow.abortions.forEach((a: any) => {
      const days = a.pregnant_month % 1 > 0 ? 15 : 0
      const pregnancyDate = moment(a.date)
        .subtract(parseInt(a.pregnant_month), 'months')
        .subtract(days, 'day')
        .format('YYYY-MM-DD')
      points.push({ x: pregnancyDate, y: 0, text: '' })
      const abortionDateM1 = moment(a.date)
        .subtract(1, 'day')
        .format('YYYY-MM-DD')
      points.push({ x: abortionDateM1, y: a.pregnant_month, text: '' })
      points.push({ x: a.date, y: 0, text: 'abortion' })
    })

    // current pregnancy
    console.log(this.cow)
    if (this.cow.pregnantSince) {
      points.push({ x: this.cow.pregnancyDate, y: 0, text: '' })
      points.push({
        x: today,
        y: this.cow.pregnantSince,
        text: '',
      })
    } else {
      points.push({ x: today, y: 0, text: '' })
    }
    points = points.sort((p1: any, p2: any) => (p1.x > p2.x ? -1 : 1))
    console.log('pints', points)

    const layout = {
      height: 200,
      margin: {
        l: 40,
        r: 40,
        t: 40,
        b: 40,
      },
      yaxis: {
        title: 'Pregnancy in month',
      },
    }
    const data = {
      x: points.map((p: any) => p.x),
      y: points.map((p: any) => p.y),
      text: points.map((p: any) => p.text),
      mode: 'lines+markers+text',
      type: 'scatter',
      textposition: 'top-left',
      line: {
        color,
      },
    }
    if (this.cow.female) {
      setTimeout(() => {
        Plotly.newPlot('pregnancy-plot', [data], layout)
        setTimeout(() => {
          this.$store.state.loading = false
        }, 500)
      }, 300)
    } else {
      this.$store.state.loading = false
    }
  }

  goBack() {
    this.$router.go(-1)
  }

  changeReason() {
    if (this.editDialog.key === 'pregnantSince') {
      if (this.editDialog.value === 0) {
        this.pregnantSinceReason = 'birth'
      } else {
        this.pregnantSinceReason = 'change'
      }
    }
  }

  openDeleteAbortionConfirm(abortion: any) {
    this.delteAbortionItem = abortion
    this.dleteAbortionDialogIsOpen = true
  }

  deleteAbortion() {
    axios
      .delete(`abortions/${this.delteAbortionItem.id}`)
      .then(() => {
        this.notify({ text: 'Abortion delted', type: 'success' })
        this.getCow()
      })
      .catch((error: any) => {
        this.notify({ text: `Server error: ${error}` })
      })
      .finally(() => {
        this.dleteAbortionDialogIsOpen = false
      })
  }

  get pregChangeReasonItems() {
    /* Change of pregnancy to None reasons */

    return [
      {
        text: 'Nacimiento',
        value: 'birth',
        disabled: this.editDialog.value > 0,
      },
      {
        text: 'Aborto',
        value: 'abortion',
        disabled: this.editDialog.value > 0,
      },
      {
        text: 'Cambio',
        value: 'change',
        disabled: this.editDialog.value === 0,
      },
    ]
  }
}
